export default "__VITE_ASSET__DWOZnsip__"